import * as React from 'react'

import { Step as AuthModalStep } from 'main/components/common/AuthModal'
import { User_user } from 'main/gql/user'
import { UnreachableCaseError } from 'main/util/ts'
import { userType, UserType } from 'main/util/user'
import AnonymousMenu from './AnonymousMenu'
import DirectorMenu from './DirectorMenu'
import ParentMenu from './ParentMenu'

interface IProps {
  user: User_user | null
  onRequestOpenAuthModal: (initialStep: AuthModalStep) => void
}

function Menu(props: IProps) {
  const { user, onRequestOpenAuthModal } = props

  return user ? (
    <LoggedInMenu user={user} />
  ) : (
    <AnonymousMenu onRequestOpenAuthModal={onRequestOpenAuthModal} />
  )
}

function LoggedInMenu(props: { user: User_user }) {
  const { user } = props
  const type = userType(user)

  switch (type) {
    case UserType.Director:
      return (
        <DirectorMenu
          isOnboarding={user.schoolhouse!.isOnboarding}
          currentOnboardingSlug={user.schoolhouse!.currentOnboardingSlug}
        />
      )
    case UserType.Parent:
      return <ParentMenu user={user} />
    default:
      throw new UnreachableCaseError(type)
  }
}

export default React.memo(Menu)
